"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.min = exports.max = exports.lerpY = exports.lerpX = void 0;
const max = numbers => Math.max(...numbers, -Infinity);
exports.max = max;
const min = numbers => Math.min(...numbers, Infinity);
// From point1 to point2, get the x value from y
exports.min = min;
const lerpX = (x1, y1, x2, y2) => y => {
  if (y1 === y2) {
    return x1;
  }
  const result = (x2 - x1) * (y - y1) / (y2 - y1) + x1;
  return Number.isNaN(result) ? 0 : result;
};

// From point1 to point2, get the y value from x
exports.lerpX = lerpX;
const lerpY = (x1, y1, x2, y2) => x => {
  if (x1 === x2) {
    return y1;
  }
  const result = (y2 - y1) * (x - x1) / (x2 - x1) + y1;
  return Number.isNaN(result) ? 0 : result;
};
exports.lerpY = lerpY;